import { Box, BrandLogo, BrandLogo300, Flex, Text, VStack } from '@elkaso-app/web-design';
import { Section } from 'layout/index';
import { LayoutProps } from 'layout/types';

export const PreLoginPageLayout = ({ sections }: LayoutProps) => {
  return (
    <Box as='main'>
      <Box as='section' minH={'100vh'}>
        <Flex h='100vh'>
          {/* Brand side panel needs real horizontal room — md and up only,
              so landscape phones aren't squeezed */}
          <VStack display={{ base: 'none', md: 'flex' }} justify='center' align='start' px='100px' bgColor='white'>
            <BrandLogo300 />

            <Text color='gray.500' fontWeight='light' letterSpacing='wider'>
              Dashboard
            </Text>
          </VStack>

          {/* Start Content */}
          <Flex
            direction='column'
            gap='xl'
            p={{ base: 'md', md: 'lg' }}
            justify='center'
            align='center'
            flexGrow={1}
            bgColor='gray.50'
            pos='relative'>
            {/* On mobile the side panel is gone — keep the brand above the form */}
            <BrandLogo display={{ base: 'block', md: 'none' }} w='140px' h='auto' />

            <Section sections={sections} name='content' />
          </Flex>
          {/* End Content */}
        </Flex>
      </Box>
    </Box>
  );
};
